angular.module('iw.frontyard.equal_repayment_calculator')
    .service('EqualRepaymentScheduler', (RepaymentScheduler) => {

    class EqualRepaymentScheduler extends RepaymentScheduler {

    constructor(siteCode, simpleRates, feeRate) {
        super(siteCode, simpleRates, feeRate);
    }
    scheduleUK(amount, duration, rate) {
        var simpleRate = this.simpleRates[duration - 1];

        this.totalAmount = amount;
        this.monthlyRepayments = amount * simpleRate / duration;
        this.totalInterestAmount = amount * simpleRate - amount;
    }
}

return EqualRepaymentScheduler;
});